import emailjs from "emailjs-com";

export const sendThankYouEmail = (name, amount, email) => {
  const service_id = process.env.REACT_APP_EMAILJS_SERVICE_ID; // Service ID
  const template_id = process.env.REACT_APP_EMAILJS_TEMPLATE_ID; // Template ID
  const public_key = process.env.REACT_APP_EMAILJS_PUBLIC_KEY; // Public Key
  return emailjs
    .send(
      service_id,
      template_id,
      {
        name,
        amount,
        email,
      },
      public_key
    )
    .then((result) => {
      console.log("Thank-you email sent!", result.text);
      return result;
    })
    .catch((error) => {
      console.error(" Error sending email:", error.text);
      throw error;
    });
};
